import User_interface from '../../../interfaces/User_interface';

export const getInitialForm = (user: User_interface) => {
  return {
    ...user,
    isFollowingPointOfSaleCalendar:
      user.isFollowingPointOfSaleCalendar ?? false,
  };
};
